import axios from 'axios';
import { API_BASE_URL } from '../config/config';
import { useAdmin } from '../context/AdminContext';
import { useMemo } from 'react';

// getFilterParams 함수를 별도로 export
export const getFilterParams = async () => {
    const getHeaders = () => {
        const token = localStorage.getItem('token');
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    };

    try {
        // 현재 로그인한 관리자의 이메일로 center_admin_info 테이블에서 권한 확인
        const response = await axios.get(`${API_BASE_URL}/api/check-admin-email`, {
            headers: getHeaders()
        });

        console.log('관리자 권한 확인 응답:', response.data);

                    // 서버에서 반환한 권한 정보 확인
            if (response.data && response.data.isSuperAdmin) {
                console.log('슈퍼 관리자 권한 확인됨 - 필터 없음');
                localStorage.setItem('is_super_admin', 'true'); // 슈퍼관리자 플래그 저장
                
                // 슈퍼 관리자의 경우에도 adminInfo를 localStorage에 저장
                const adminInfo = response.data.adminInfo || {};
                if (adminInfo) {
                    localStorage.setItem('adminInfo', JSON.stringify({
                        adminInfo,
                        isSuperAdmin: response.data.isSuperAdmin,
                        success: response.data.success
                    }));
                }
                
                return {
                    group_role: 'MASTER',  // 슈퍼 관리자의 경우 MASTER 권한 부여
                    is_super_admin: true   // 슈퍼 관리자 플래그 추가
                };
            }

        // 일반 관리자는 기존 필터 적용
        console.log('일반 관리자 필터 적용');
        localStorage.setItem('is_super_admin', 'false'); // 일반 관리자 플래그 저장
        const adminInfo = response.data.adminInfo || {};
        if (adminInfo) {
            localStorage.setItem('adminInfo', JSON.stringify({
                adminInfo,
                isSuperAdmin: response.data.isSuperAdmin,
                success: response.data.success
            }));
        }
        if (adminInfo.admin_group_ids) {
            localStorage.setItem('admin_group_ids', JSON.stringify(adminInfo.admin_group_ids));
        }
        if (adminInfo.admin_group_id) {
            localStorage.setItem('admin_group_id', String(adminInfo.admin_group_id));
        }
        if (adminInfo.user_group_ids) {
            localStorage.setItem('user_group_ids', JSON.stringify(adminInfo.user_group_ids));
        }
        if (adminInfo.user_group_id) {
            localStorage.setItem('user_group_id', String(adminInfo.user_group_id));
        }
        const params = {};
        if (adminInfo?.hospitalId) params.hospital_id = adminInfo.hospitalId;
        if (adminInfo?.regionCode) params.region_code = adminInfo.regionCode;
        if (adminInfo?.districtCode) params.district_code = adminInfo.districtCode;
        params.group_role = adminInfo.group_role || adminInfo.group_role || null;
        params.group_id = adminInfo.groupId || adminInfo.group_id || null;
        params.admin_group_id = adminInfo.admin_group_id || null;
        params.admin_group_ids = adminInfo.admin_group_ids || null;
        params.user_group_id = adminInfo.user_group_id || null;
        params.user_group_ids = adminInfo.user_group_ids || null;
        return params;
    } catch (error) {
        console.error('관리자 권한 확인 중 오류:', error);
        // 확인하지 못했으면 권한을 넓게 두지 않는다. 앞선 세션의 is_super_admin=true 나
        // 그룹 id 가 남아 있으면 그 권한으로 메뉴·목록이 그려지므로 일반 관리자·그룹 없음으로 둔다.
        // (목록 범위 자체는 서버 adminScope 게이트가 DB 로 다시 정한다.)
        localStorage.setItem('is_super_admin', 'false');
        ['admin_group_ids', 'admin_group_id', 'user_group_ids', 'user_group_id'].forEach((key) => localStorage.removeItem(key));
        // 오류 발생 시 기본 필터 적용
        console.log('오류 발생으로 기본 필터 적용');
        const params = {};
        // adminInfo가 함수 스코프 밖에 있으므로 localStorage에서 가져오거나 기본값 사용
        params.is_super_admin = false;  // 오류 시 일반 관리자로 처리
        return params;
    }
};

// API 클라이언트 생성 함수
export const createApiClient = (adminInfo) => {
    const getHeaders = () => {
        const token = localStorage.getItem('token');
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    };

    // 모든 메뉴의 접근 권한을 한 번에 가져오는 함수
    const getMenuAccess = async () => {
        try {
            const params = await getFilterParams();
            console.log('getMenuAccess params:', params); // 이 줄을 추가!
            
            // 슈퍼 관리자인 경우
            if (params.is_super_admin) {
                console.log('슈퍼 관리자 메뉴 접근 권한 설정 - 모든 권한 허용');
                return {
                    status: 'success',
                    menuAccess: {
                        controlCenter: true,
                        dashboard: true,
                        userManagement: true,
                        messageManagement: true,
                        operations: true
                    }
                };
            }

            // group_role이 CANDIDATE면 운영관리 메뉴 비활성화
            if (params.group_role === 'CANDIDATE') {
                return {
                    status: 'success',
                    menuAccess: {
                        controlCenter: true,
                        dashboard: true,
                        userManagement: true,
                        messageManagement: true,
                        operations: false
                    }
                };
            }

            // 그 외에는 모두 operations: true
            return {
                status: 'success',
                menuAccess: {
                    controlCenter: true,
                    dashboard: true,
                    userManagement: true,
                    messageManagement: true,
                    operations: true
                }
            };
        } catch (error) {
            console.error('메뉴 접근 권한 조회 실패:', error);
            return {
                status: 'success',
                menuAccess: {
                    controlCenter: true,
                    dashboard: true,
                    userManagement: true,
                    messageManagement: true,
                    operations: true
                }
            };
        }
    };

    return {
        // GET 요청
        get: async (endpoint, params = {}) => {
            const filterParams = await getFilterParams();
            console.log('API 요청 필터 파라미터:', filterParams);
            
            // 슈퍼 관리자인 경우 is_super_admin 파라미터 추가
            if (filterParams && filterParams.is_super_admin) {
                const queryParams = { ...params, is_super_admin: 'true' };
                console.log('최종 쿼리 파라미터:', queryParams);
                
                const response = await axios.get(`${API_BASE_URL}${endpoint}`, {
                    headers: getHeaders(),
                    params: queryParams
                });
                return response.data;
            }
            
            // 일반 관리자의 경우 필터 파라미터 포함
            const queryParams = filterParams === null ? params : { ...params, ...filterParams };
            console.log('최종 쿼리 파라미터:', queryParams);
            
            const response = await axios.get(`${API_BASE_URL}${endpoint}`, {
                headers: getHeaders(),
                params: queryParams
            });
            return response.data;
        },

        // POST 요청
        post: async (endpoint, data = {}) => {
            const filterParams = await getFilterParams();
            console.log('API 요청 필터 파라미터:', filterParams);
            const response = await axios.post(`${API_BASE_URL}${endpoint}`, 
                filterParams === null ? data : { ...data, ...filterParams }, 
                {
                    headers: getHeaders()
                }
            );
            return response.data;
        },

        // PUT 요청
        put: async (endpoint, data = {}) => {
            const filterParams = await getFilterParams();
            console.log('API 요청 필터 파라미터:', filterParams);
            const response = await axios.put(`${API_BASE_URL}${endpoint}`, 
                filterParams === null ? data : { ...data, ...filterParams }, 
                {
                    headers: getHeaders()
                }
            );
            return response.data;
        },

        // DELETE 요청
        delete: async (endpoint) => {
            const filterParams = await getFilterParams();
            console.log('API 요청 필터 파라미터:', filterParams);
            const response = await axios.delete(`${API_BASE_URL}${endpoint}`, {
                headers: getHeaders(),
                params: filterParams === null ? {} : filterParams
            });
            return response.data;
        },

        // 메뉴 접근 권한 조회
        getMenuAccess
    };
};

// API 호출을 위한 커스텀 훅
export const useApi = () => {
    const { adminInfo } = useAdmin();
    
    // adminInfo가 변경될 때만 새로운 API 클라이언트를 생성
    return useMemo(() => createApiClient(adminInfo), [adminInfo]);
}; 